import PanelPeriodControl from "connected-components/dashboard/components/panel-period-control"
import { useKPIData } from "../hooks/use-kpi-data"

interface KPIPanelPeriodControlProps {
  isPerformance?: boolean
}

export default function KPIPanelPeriodControl({ isPerformance = true }: KPIPanelPeriodControlProps) {
  const { dateOverride, setDateOverride, clearDateOverride, earliestDate, latestDate, startDate, endDate, isDateOverrideActive } = useKPIData()

  return (
    <PanelPeriodControl
      dates={{ earliestDate, latestDate, startDate, endDate }}
      dateOverride={dateOverride}
      isDateOverrideActive={isDateOverrideActive}
      setDateOverride={setDateOverride}
      clearDateOverride={clearDateOverride}
      isPerformance={isPerformance}
    />
  )
}
